import React from 'react';

import { Link } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import { Field } from 'client/blocks-redesign/form/Field/Field';
import { HostsSelect } from 'client/blocks-redesign/form/HostsSelect/HostsSelect';
import { wrapInText } from 'client/lib/i18n-utils';
import * as keyset from 'i18n/SettingsLabels';

const DOCUMENTATION_BRAND = 'https://webmaster.yandex.ru/sites/add/';

const t = i18n(keyset);

interface Props {
    error?: string;
    disabled: boolean;
    onChange?: (updated: string) => void;
    brandVerificationWebsite?: string;
    brandIsVerified?: boolean;
}

const description = wrapInText((s) => (
    <Link view="normal" href={DOCUMENTATION_BRAND} target="_blank">
        {s}
    </Link>
))(t('description-verification'));

export const BrandVerification: React.FC<Props> = ({
    error,
    disabled,
    onChange = () => {},
    brandVerificationWebsite,
    brandIsVerified,
}) => {
    const displayBrandVerificationError = !!brandVerificationWebsite && !brandIsVerified;

    return (
        <Field
            fieldTitle={t('brand-verification-website')}
            fieldDescription={description}
            error={displayBrandVerificationError ? t('not-verified') : undefined}
        >
            <HostsSelect value={brandVerificationWebsite} onChange={onChange} error={error} disabled={disabled} />
        </Field>
    );
};
